import { Caption } from '@xo-union/tk-ui-typography';
import React from 'react';

import { TrackingContext } from '../../TrackingContext';
import styles from './onlineRsvp.scss';
import { sanitizeEventWithQuestions } from '../WeddingPageCard/helper';
import RsvpInfo from '../WeddingPageCard/RsvpInfo';
import { useEventModalReducer } from '../WeddingPageCard/useEventModal';
import { TypesOfEvents, Event } from '../WeddingPageCard/EventList';

const OnlineRsvp: React.FC = () => {
  const { dispatchOpen } = useEventModalReducer();

  const { track } = React.useContext(TrackingContext);
  const onClick = (event: Event) => {
    const { __typename, ...eventBody } = event;
    dispatchOpen({
      type: (event.type as TypesOfEvents) || 'WeddingEvent',
      event: sanitizeEventWithQuestions(eventBody),
    });
    track('WWS Dashboard Interaction', {
      action: 'event update initiated',
    });
  };

  return (
    <div className={styles.fullWidth}>
      <Caption>Online RSVP</Caption>
      <RsvpInfo onEventModal={onClick} />
    </div>
  );
};

export default OnlineRsvp;
